module.exports = __webpack_public_path__ + "static/media/pagopa.482426c6.svg";